<script>
import { formatMinskDate, capitalizeFirst } from '@/scripts/tools.js';

export default {
    name: 'UserSubscriptionHistory',
    props: {
        history: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasData() {
            return this.history && this.history.length > 0;
        },
    },
    methods: {
        formatDate: formatMinskDate,
        capitalizeFirst,
        truncateReason(reason) {
            if (!reason) return '—';
            if (reason.length <= 40) return reason;
            return reason.substring(0, 40) + '...';
        },
    },
};
</script>

<template>
    <div class="subscription_history_content">
        <div v-if="isLoading" class="loading_state">
            Loading subscription history...
        </div>
        <div v-else-if="!hasData" class="empty_state">
            No subscription history found
        </div>
        <div v-else class="table_wrapper">
            <table class="history_table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Status Change</th>
                        <th>Reason</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="record in history" :key="record.id">
                        <td>{{ formatDate(record.created_at) }}</td>
                        <td class="status_change_cell">
                            <span v-if="record.old_status" class="status_from">
                                {{ capitalizeFirst(record.old_status) }}
                            </span>
                            <span v-if="record.old_status" class="status_arrow">
                                →
                            </span>
                            <span class="status_to">
                                {{ capitalizeFirst(record.new_status) }}
                            </span>
                        </td>
                        <td :title="record.change_reason">
                            {{ truncateReason(record.change_reason) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
.subscription_history_content {
    padding: 5px 0 0 0;
}

.loading_state,
.empty_state {
    padding: 30px;
    text-align: center;
    color: var(--background-text, #ffffff);
    opacity: 0.7;
}

.table_wrapper {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
}

.history_table {
    width: 100%;
    border-collapse: collapse;
    min-width: 550px;
}

.history_table thead {
    position: sticky;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
}

.history_table th {
    padding: 10px 12px;
    text-align: left;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    color: var(--background-text, #ffffff);
    opacity: 0.8;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
}

.history_table td {
    padding: 10px 12px;
    color: var(--background-text, #ffffff);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 14px;
}

.history_table tbody tr:hover td {
    background: rgba(255, 255, 255, 0.05);
}

.status_change_cell {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
}

.status_from {
    opacity: 0.7;
}

.status_arrow {
    opacity: 0.5;
}

.status_to {
    font-weight: 500;
}
</style>
